import React, { FC, useEffect } from 'react';
import { Box, Text, Separator, SeparatorType } from '@bechtel/gds';
import { Trans } from '@lingui/macro';
import { MAP_MARKER_ROD_ROOM_STATS_SUMMARY } from '@bechtel/client-gql';
import { useLazyQuery } from '@apollo/client';
import { RodRoomStats, RodRoomStatsInput, RodRoomStatusFlag } from '@bechtel/types';
import { find, get } from 'lodash';
interface RodRoomInfoProps {
  rodRoomId: string;
  rodRoomName: string;
  locationDescription?: string;
}

export const RodRoomInfo: FC<RodRoomInfoProps> = ({ rodRoomId, rodRoomName, locationDescription }) => {
  const [loadMapMarkerRodRoomStats, { data: statsData }] = useLazyQuery<
    { rodRoomStatsSummary: RodRoomStats },
    { input: RodRoomStatsInput }
  >(MAP_MARKER_ROD_ROOM_STATS_SUMMARY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (!rodRoomId) return;
    loadMapMarkerRodRoomStats({
      variables: {
        input: {
          rodRoomId:rodRoomId,
        },
      },
    });
  }, [rodRoomId]);

  const numPriority = statsData?.rodRoomStatsSummary?.numPriority ? statsData?.rodRoomStatsSummary?.numPriority : 0;
  const rodroomStats = get(statsData?.rodRoomStatsSummary, 'rodRoomStatsSummary');

  const getRodRoomStats = (statusFlag: RodRoomStatusFlag) => {
    return (
      get(
        find(rodroomStats, (statusStat) => statusStat?.status === statusFlag),
        'stats'
      ) || 0
    );
  };
  const today = getRodRoomStats(RodRoomStatusFlag.TODAY);
  const tomorrow = getRodRoomStats(RodRoomStatusFlag.TOMORROW);
  return (
    <Box style={{ maxWidth: '284px' }} flexDirection={{ sm: 'column' }} key={rodRoomId}>
      <Text size="400" weight="600" data-testid="rod-marker-header">
        {rodRoomName}
      </Text>
      <Box mt={{ sm: '400' }} data-testid="rod-marker-desc">
        <Text color="grey.500" size="400" style={{ whiteSpace: 'pre-wrap' }}>
          {locationDescription}
        </Text>
      </Box>
      <Separator spacing="500" type={SeparatorType.HORIZONTAL} color="grey.300" />

      <Box data-testid="rod-marker-id">
        <Box mr={{ sm: '700' }}>
          <Text weight={600} size="400">
            {today}
          </Text>
          <Text weight={400} size="400" color="grey.1000">
            &nbsp;<Trans>Today</Trans>
          </Text>
        </Box>
        <Box mr={{ sm: '700' }}>
          <Text weight={600} size="400">
            {tomorrow}
          </Text>
          <Text size="400" weight={400} color="grey.1000">
            &nbsp;<Trans>Tomorrow</Trans>
          </Text>
        </Box>
        <Box>
          <Text color={'orange.500'} size="400" weight={600}>
            {numPriority}
          </Text>
          <Text size="400" weight={400} color="grey.1000">
            &nbsp;<Trans>Priority</Trans>
          </Text>
        </Box>
      </Box>
    </Box>
  );
};
